
/**
 * The `mouseup` event label
 */
export const MOUSEUP = 'mouseup';

/**
 * The `mousedown` event label
 */
export const MOUSEDOWN = 'mousedown';

/**
 * The `mousemove` event label
 */
export const MOUSEMOVE = 'mousemove';

/**
 * The `mouseout` event label
 */
export const MOUSEOUT = 'mouseout';

/**
 * The `click` event label
 */
export const CLICK = 'click';

/**
 * The `keydown` event label
 */
export const KEYDOWN = 'keydown';

/**
 * The `keyup` event label
 */
export const KEYUP = 'keyup';

/**
 * The `keypress` event label
 */
export const KEYPRESS = 'keypress';
